import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

import { EmptyState } from "../empty-state";

import type { Column } from "./types";

interface Props<T> {
  columns: Column<T>[];
  rows: T[];
  loading?: boolean;
  hasMore: boolean;
  onLoadMore?: () => void;
  mobileRender?: (row: T, actionsNode?: React.ReactNode) => React.ReactNode;
  actions?: (row: T) => React.ReactNode;
}

export function DataTableMobileView<T>({
  columns,
  rows,
  loading,
  hasMore,
  onLoadMore,
  mobileRender,
  actions,
}: Props<T>) {
  return (
    <div className="flex flex-col gap-3">
      {loading ? (
        <p className="py-6 text-center text-sm text-muted-foreground">
          Memuat...
        </p>
      ) : rows.length === 0 ? (
        <EmptyState />
      ) : (
        rows.map((row, i) => {
          const actionsNode = actions ? actions(row) : null;
          if (mobileRender) {
            return <div key={i}>{mobileRender(row, actionsNode)}</div>;
          }
          return (
            <Card key={i} className="gap-2 py-4">
              <CardContent className="space-y-2 px-4">
                {columns.map((c) =>
                  c.key === "__actions" ? (
                    <div
                      key={c.key}
                      className="flex justify-end pt-2 border-t border-border/40"
                    >
                      {c.render(row)}
                    </div>
                  ) : (
                    <div
                      key={c.key}
                      className="flex items-start justify-between gap-3 text-sm"
                    >
                      {c.label && (
                        <span className="text-muted-foreground shrink-0">
                          {c.label}
                        </span>
                      )}
                      <div className="text-right min-w-0">{c.render(row)}</div>
                    </div>
                  ),
                )}
              </CardContent>
            </Card>
          );
        })
      )}

      {hasMore && (
        <Button
          variant="outline"
          className="w-full"
          onClick={() => onLoadMore?.()}
        >
          Muat lebih banyak
        </Button>
      )}
    </div>
  );
}
